export interface Size
{
    width: number;
    height: number;
}

export interface Margin
{
    top: number;
    right: number;
    bottom: number;
    left: number;
}

export interface Rect
{
    x: number;
    y: number;
    width: number;
    height: number;
}

export type Point = { x: number, y: number }

export function inset (parent: Rect, margin: Margin) : Rect
{
    return  {
        x: margin.left,
        y: margin.top,
        width: parent.width - margin.left - margin.right,
        height: parent.height - margin.top - margin.bottom
    };
}

export function getMaxX (frame: Rect)
{
    return frame.x + frame.width;
}

export function getMaxY (frame: Rect)
{
    return frame.y + frame.height;
}

export function barycentric(x1: number | { valueOf(): number },
                            x2: number | { valueOf(): number },
                            x: number | { valueOf(): number }):number
{
    return (num(x) - num(x1)) / (num(x2) - num(x1));
}

function num (x: number | { valueOf(): number })
{
    return (typeof x === 'number')? x : x.valueOf();
}

// Returns true if point `p` is inside `rect`
export function inside(p: Point | [number, number], rect: Rect)
{
    var x,y;
    if (p && p.constructor === Array)
        ([x, y] = p as Array<number>);
    if (p && p.constructor === Object)
        ({x, y} = (p as Point));
    
    return (x >= rect.x && x <= getMaxX(rect))
        && (y >= rect.y && y <= getMaxY(rect));
}

export function point (p: [number, number]): Point
{
    return { x: p[0], y: p[1] };
}

// calculates SVGRect for provided SVG element
export function getRect(elem: SVGGraphicsElement): SVGRect
{
    const transform = getParentCT(elem);
    return transform(elem.getBBox());
}

// Get top left corner point with respect to parent's coordinate system
export function getOrigin(elem: SVGGraphicsElement): Point
{
    const transform = getParentCT(elem);
    return transform({ x: 0, y: 0 });
}

export function getParentCT(from: SVGGraphicsElement)
{
    return getCT(from, from.parentNode as SVGGraphicsElement);
}

// idea: https://stackoverflow.com/questions/26049488/how-to-get-absolute-coordinates-of-object-inside-a-g-group
export function getCT(from: SVGGraphicsElement, to: SVGGraphicsElement)
{
    // matrix shape: https://www.w3.org/TR/SVGTiny12/coords.html#TransformMatrixDefined
    // transform = (from ViewPort to Target) * (from Source to ViewPort)
    return <T extends Point>(p: T): T => {
        const transform = to.getScreenCTM().inverse().multiply(from.getScreenCTM());
        p.x = transform.a*p.x + transform.c*p.y + transform.e;
        p.y = transform.b*p.x + transform.d*p.y + transform.f;
        return p;
    };
}


// WEBPACK FOOTER //
// ./src/charts/Geometry.ts